import React, { useState, useEffect, useRef } from 'react'
import Snackbar from '@mui/material/Snackbar';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box, Card, CardContent, Typography, Divider, Button, Dialog, DialogTitle, DialogContent, IconButton, TextField, DialogActions, Alert, CircularProgress } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import MlmcreditDashboard from '../MlmcreditDashboard';
import { getListAPI as getMlmcreditList } from 'components/mlmcredit/MlmcreditAPI';
import { setMlmcreditList, setMlmcreditDashboardMlmcreditList } from 'store/slice/DmpSlice';
import { getMlmcreditInfoByPartneridAPI, getMlmcreditInfoByMlmuseridAPI, getListAPI } from 'components/mlmcredit/MlmcreditAPI';

import { openDrawer } from './../../../store/slice/MenuSlice';
import CreditStatement from './creditmgmt/CreditStatement';
import BankTransferReq from './creditmgmt/BankTransferReq';
import { getTransferreqInfoAPI, initTransferReqAPI } from 'api/CoreMlmmgmtWebServices';
import BankDetails from '../../../core/components/profile-mgmt/BankDetails';
import { setRefreshCreditSummary } from 'store/slice/EcomSlice';
import DemographicDetails from 'core/components/profile-mgmt/DemographicDetails';

export default function MlmcreditPageImpl() {
    const dispatch = useDispatch();
    const { mlmUserObj,bankDetailsAvailable } = useSelector((state) => state.ecomslice.mlm);
    const { authuserid } = useSelector((state) => state.headerslice.appuserInfo);
    const { userprofileInfo } = useSelector((state) => state.headerslice);
    const [openBankTransferDialog, setOpenBankTransferDialog] = useState(false);
    const [openPendingTransferDialog, setOpenPendingTransferDialog] = useState(false);
    const [openStatementDialog, setOpenStatementDialog] = useState(false);
    const [openTransferAmountDialog, setOpenTransferAmountDialog] = useState(false);
    const [showBankDetailsStep, setShowBankDetailsStep] = useState(true);
    const [hasBankDetails, setHasBankDetails] = useState(false);
    const [transferAmount, setTransferAmount] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [creditBalance, setCreditBalance] = useState(0);
    const [tranferInProgressBalance, setTranferInProgressBalance] = useState(10);
    const [isBalanceLoading, setIsBalanceLoading] = useState(true);
    const [showMinBalanceSnackbar, setShowMinBalanceSnackbar] = useState(false);
    const [showPanSnackbar, setShowPanSnackbar] = useState(false);
    const [showAadhaarSnackbar, setShowAadhaarSnackbar] = useState(false);
    const [isTransferStatusPolling, setIsTransferStatusPolling] = useState(false);
    const [transferStatusMessage, setTransferStatusMessage] = useState('');
    const [transferStatusCode, setTransferStatusCode] = useState(null);
    const [transferRequestAmount, setTransferRequestAmount] = useState(null);
    const [transferSuccessInfo, setTransferSuccessInfo] = useState(null);
    const transferPollTimeoutRef = useRef(null);
    const isTransferStatusScreen = !showBankDetailsStep && (isTransferStatusPolling || transferStatusCode !== null);
    const isTransferStatusConcluded = !isTransferStatusPolling && transferStatusCode !== null && transferStatusCode !== 1;

    // Sample data - replace with actual data from your API
    const paidCredit = 0;
    const underBankTransfer = 0;

    const getMlmcreditListSuccess = (apiResponse) => {
        dispatch(setMlmcreditList(apiResponse));
        dispatch(setMlmcreditDashboardMlmcreditList(apiResponse));
    }

    useEffect(() => {
        // Fetch credit data here
    }, []);
    useEffect(() => {
        setHasBankDetails(bankDetailsAvailable);
    }, [bankDetailsAvailable]);

    useEffect(() => {
        return () => {
            if (transferPollTimeoutRef.current) {
                clearTimeout(transferPollTimeoutRef.current);
            }
        };
    }, []);

    const handleRaiseBankTransferRequest = () => {
        setTransferAmount('');
        setShowSuccess(false);
        setErrorMessage('');
        setShowBankDetailsStep(true);
        setOpenTransferAmountDialog(true);
    };

    const handleCloseTransferAmountDialog = () => {
        if (transferPollTimeoutRef.current) {
            clearTimeout(transferPollTimeoutRef.current);
        }
        setOpenTransferAmountDialog(false);
        setTransferAmount('');
        setShowSuccess(false);
        setErrorMessage('');
        setShowBankDetailsStep(true);
        setIsTransferStatusPolling(false);
        setTransferStatusMessage('');
        setTransferStatusCode(null);
        setTransferRequestAmount(null);
        setTransferSuccessInfo(null);
    };

    const handleNextToBankTransfer = () => {
        if (mlmUserObj.pan === '') {
            setShowPanSnackbar(false);
            setTimeout(() => setShowPanSnackbar(true), 50);
        } else if (mlmUserObj.panvalidated !== true) {
            setShowPanSnackbar(false);
            setTimeout(() => setShowPanSnackbar(true), 50);
        } else if (mlmUserObj.aadharnumber === '') {
            setShowAadhaarSnackbar(false);
            setTimeout(() => setShowAadhaarSnackbar(true), 50);
        } else {
            setShowBankDetailsStep(false);
        }
    };

    const handleBackToBankDetails = () => {
        setShowBankDetailsStep(true);
    };

    const handleCloseTransferStatusDialog = () => {
        dispatch(setRefreshCreditSummary());
        handleCloseTransferAmountDialog();
    };

    const handleInitiateTransfer = async () => {
        const amount = parseFloat(transferAmount);
        
        if (!transferAmount || amount <= 0) {
            setErrorMessage('Please enter a valid amount');
            return;
        }

        if (amount > creditBalance) {
            setErrorMessage(`Amount cannot exceed your available balance of ₹${creditBalance.toFixed(2)}`);
            return;
        }

        setIsLoading(true);
        setErrorMessage('');
        initTransferReqAPI(
            {amount: amount},
            (apiResponse) => {
                const transferreqInfo = apiResponse?.transferreqInfo || apiResponse?.TransferreqInfo;
                const transferreqId = transferreqInfo?.id;
                setTransferRequestAmount(amount);
                setTransferAmount('');
                setIsLoading(false);
                if (transferreqId) {
                    setTransferStatusCode(1);
                    setTransferStatusMessage(`Bank Transfer for ₹${amount.toFixed(2)}/- is initiated and waiting for transfer status.`);
                    setIsTransferStatusPolling(true);
                    startTransferStatusPolling(transferreqId, amount, 1);
                } else {
                    setTransferStatusCode(null);
                    setTransferStatusMessage('');
                    setErrorMessage('Transfer request created but tracking id is missing.');
                }
            },
            (error) => {
                setErrorMessage(
                    typeof error === 'string'
                        ? error
                        : error?.message || 'An error occurred while initiating transfer request. Please try again.'
                );
                setIsLoading(false);
            }
        );
    };

    const startTransferStatusPolling = (transferreqId, amount, attemptNumber) => {
        if (transferPollTimeoutRef.current) {
            clearTimeout(transferPollTimeoutRef.current);
        }

        if (attemptNumber > 5) {
            setIsTransferStatusPolling(false);
            setTransferStatusCode(1);
            setTransferStatusMessage('Bank Transfer Request was initiated but status is still Pending, we will inform you when transfer is initiated.');
            return;
        }

        getTransferreqInfoAPI(
            transferreqId,
            (response) => {
                const reqstatus = response?.reqstatus;
                if (reqstatus === 2) {
                    const requestedAmount = parseFloat(response?.amount ?? amount ?? 0);
                    const transferredAmount = parseFloat(response?.transferedamount ?? amount ?? 0);
                    const taxDeducted = parseFloat(response?.taxdeducted ?? 0);
                    setIsTransferStatusPolling(false);
                    setTransferStatusCode(2);
                    setShowSuccess(true);
                    setTransferSuccessInfo({
                        requestedAmount,
                        transferredAmount,
                        taxDeducted
                    });
                    setTransferStatusMessage(
                        `Transfer request of ₹${requestedAmount.toFixed(2)}/- was accepted and ₹${transferredAmount.toFixed(2)}/- is transferred after deducting TDS ₹${taxDeducted.toFixed(2)}/-.`
                    );
                    return;
                }

                if (reqstatus !== 1) {
                    setIsTransferStatusPolling(false);
                    setTransferStatusCode(reqstatus ?? 0);
                    if (reqstatus === 3) {
                        setTransferStatusMessage('Bank Transfer Initiation was failed. We will analyse and get back to you.');
                    } else {
                        setTransferStatusMessage(`Bank Transfer for ₹${amount.toFixed(2)}/- could not be completed.`);
                    }
                    return;
                }

                setTransferStatusCode(1);
                setTransferStatusMessage(`Bank Transfer for ₹${amount.toFixed(2)}/- is initiated and waiting for transfer status.`);
                transferPollTimeoutRef.current = setTimeout(() => {
                    startTransferStatusPolling(transferreqId, amount, attemptNumber + 1);
                }, 5000);
            },
            () => {
                transferPollTimeoutRef.current = setTimeout(() => {
                    startTransferStatusPolling(transferreqId, amount, attemptNumber + 1);
                }, 5000);
            }
        );
    };

    const handleOpenBankTransferDialog = () => {
        setOpenBankTransferDialog(true);
    };

    const handleCloseBankTransferDialog = () => {
        setOpenBankTransferDialog(false);
    };

    const handleOpenPendingTransferDialog = () => {
        setOpenPendingTransferDialog(true);
    };

    const handleClosePendingTransferDialog = () => {
        setOpenPendingTransferDialog(false);
    };

    const handleOpenStatementDialog = () => {
        setOpenStatementDialog(true);
    };

    const handleCloseStatementDialog = () => {
        setOpenStatementDialog(false);
    };

    const isAmountValid = () => {
        const amount = parseFloat(transferAmount);
        return transferAmount && amount > 0 && amount <= creditBalance;
    };
    const managerBankTransferRequest = () => {
        console.log('Credit Balance:', creditBalance);
        if (creditBalance < 200) {
            setShowMinBalanceSnackbar(true); // reset if already open
            //setTimeout(() => setShowMinBalanceSnackbar(true), 1000);
        } else {
            console.log('Raising bank transfer request');
            handleRaiseBankTransferRequest();
        }
    }

    return (
        <Grid container spacing={3} sx={{  }}>
            <Grid item xs={12}>
                {/* Credit Balance Summary Card */}
                <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12}>
                        <Card sx={{ backgroundColor: 'success.50', height: '100%' }}>
                            <CardContent>
                                {/* First Row - Credit Balance (Centered) */}
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', gap: 2, mb: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <AccountBalanceIcon sx={{ fontSize: 40, color: 'success.main' }} />
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.875rem', display: 'block' }}>
                                                Credit Balance
                                            </Typography>
                                            {isBalanceLoading ? (
                                                <Box sx={{ display: 'flex', justifyContent: 'center', py: 0.5 }}>
                                                    <CircularProgress size={24} color="success" />
                                                </Box>
                                            ) : (
                                                <Typography variant="h4" sx={{ fontWeight: 700, color: 'success.main' }}>
                                                    ₹{creditBalance.toFixed(2)}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Transfer in Progress Message */}
                                {tranferInProgressBalance > 0 && (
                                    <Box sx={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        gap: 1,
                                        mb: 2,
                                        p: 1.5,
                                        backgroundColor: 'secondary.100',
                                        borderRadius: 1,
                                    }}>
                                        <InfoIcon sx={{ fontSize: 20, color: 'info.main' }} />
                                        <Typography variant="body2" sx={{ fontSize: '0.80rem', color: 'info.main', fontWeight: 500 }}>
                                            In Progress - Transfer request of worth ₹{tranferInProgressBalance.toFixed(2)}
                                        </Typography>
                                    </Box>
                                )}

                                {/* Divider */}
                                <Divider sx={{ mt: tranferInProgressBalance > 0 ? 2 : 5, mb: 2 }} />

                                {/* Second Row - Transfer History and Bank Transfer */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Button
                                        variant="text"
                                        color="primary"
                                        startIcon={<VisibilityIcon />}
                                        onClick={handleOpenPendingTransferDialog}
                                        sx={{
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            '&:hover': {
                                                backgroundColor: 'primary.50'
                                            }
                                        }}
                                    >
                                        Transfer History
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        startIcon={<SendIcon />}
                                        onClick={managerBankTransferRequest}
                                        sx={{
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            '&:hover': {
                                                backgroundColor: 'success.100'
                                            }
                                        }}
                                        disabled={creditBalance === 0}
                                    >
                                        Bank Transfer
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* Credit Statement Section */}
                <Box sx={{ 
                    mb: 1, 
                    p: 1, 
                    // maxHeight: {xs:'40vh', sm:'55vh', md:'65vh', lg:'75vh'}, 
                    // overflow: 'auto',
                    // '&::-webkit-scrollbar': {
                    //     width: '8px',
                    // },
                }}>
                    <CreditStatement
                        setBalance={setCreditBalance}
                        setTranferInProgressBalance={setTranferInProgressBalance}
                        setBalanceLoading={setIsBalanceLoading}
                    />
                </Box>
            </Grid>

            {/* Bank Transfer Amount Dialog */}
            <Dialog
                open={openTransferAmountDialog}
                onClose={isTransferStatusScreen && !isTransferStatusConcluded ? undefined : handleCloseTransferAmountDialog}
                maxWidth="sm"
                fullWidth
                disableEscapeKeyDown={isTransferStatusScreen && !isTransferStatusConcluded}
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {showBankDetailsStep ? 'Bank Account Details' : 'Bank Transfer Request'}
                        </Typography>
                        {!(isTransferStatusScreen && !isTransferStatusConcluded) ? (
                            <IconButton
                                onClick={handleCloseTransferAmountDialog}
                                sx={{
                                    color: 'text.secondary',
                                    '&:hover': {
                                        backgroundColor: 'action.hover'
                                    }
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        ) : null}
                    </Box>
                </DialogTitle>
                <DialogContent dividers sx={{ backgroundColor: '#f5f5f5', position: 'relative', p: 2 }}>
                    {/* Snackbars rendered at the top of the dialog */}
                    <Box sx={{ position: 'absolute', top: 120, left: 0, width: '100%', zIndex: 1301 }}>
                        <Snackbar
                            open={showMinBalanceSnackbar}
                            autoHideDuration={3000}
                            onClose={() => setShowMinBalanceSnackbar(false)}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            sx={{
                                '& .MuiSnackbarContent-root': {
                                    mt: '20px',
                                    backgroundColor: (theme) => theme.palette.info.main,
                                    color: (theme) => theme.palette.info.contrastText,
                                }
                            }}
                            message="Minimum credit balance of ₹200 is required to raise a bank transfer request."
                        />
                        <Snackbar
                            open={showPanSnackbar}
                            autoHideDuration={3000}
                            onClose={() => setShowPanSnackbar(false)}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            sx={{
                                '& .MuiSnackbarContent-root': {
                                    mt: '20px',
                                    backgroundColor: (theme) => theme.palette.info.main,
                                    color: (theme) => theme.palette.info.contrastText,
                                }
                            }}
                            message="PAN validation is mandatory to raise bank transfer request."
                        />
                        <Snackbar
                            open={showAadhaarSnackbar}
                            autoHideDuration={3000}
                            onClose={() => setShowAadhaarSnackbar(false)}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                            sx={{
                                '& .MuiSnackbarContent-root': {
                                    mt: '20px',
                                    backgroundColor: (theme) => theme.palette.info.main,
                                    color: (theme) => theme.palette.info.contrastText,
                                }
                            }}
                            message="Aadhaar Number is mandatory to raise bank transfer request."
                        />
                    </Box>
                    {showBankDetailsStep ? (
                        <Box>
                            <BankDetails onBankDetailsChange={setHasBankDetails} />
                        </Box>
                    ) : (isTransferStatusPolling || transferStatusCode !== null) ? (
                        <Box sx={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            py: 4,
                            gap: 2
                        }}>
                            {isTransferStatusPolling ? (
                                <CircularProgress />
                            ) : transferStatusCode === 2 ? (
                                <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main' }} />
                            ) : (
                                <InfoIcon sx={{ fontSize: 64, color: 'info.main' }} />
                            )}
                            <Typography variant="h6" sx={{ fontWeight: 600, color: transferStatusCode === 2 ? 'success.main' : 'info.main' }}>
                                {transferStatusCode === 2 ? 'Success!' : transferStatusCode === 3 ? 'Transfer Failed' : 'Transfer Initiated'}
                            </Typography>
                            {transferStatusCode === 2 && transferSuccessInfo ? (
                                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            p: 2,
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: 1,
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                            textAlign: 'center'
                                        }}
                                    >
                                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                            Transfer request of{' '}
                                            <Box component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                                ₹{transferSuccessInfo.requestedAmount.toFixed(2)}/-
                                            </Box>{' '}
                                            was accepted.
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            p: 2,
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: 1,
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                            textAlign: 'center'
                                        }}
                                    >
                                        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                            <Box component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                                ₹{transferSuccessInfo.transferredAmount.toFixed(2)}/-
                                            </Box>{' '}
                                            is transferred after deducting TDS{' '}
                                            <Box component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                                ₹{transferSuccessInfo.taxDeducted.toFixed(2)}/-
                                            </Box>
                                            .
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : (
                                <Typography variant="body1" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                                    {transferStatusMessage}
                                </Typography>
                            )}
                        </Box>
                    ) : (
                        <>
                            {/* Balance Information Box */}
                            <Box sx={{ 
                                mb: 2, 
                                p: 2, 
                                backgroundColor: '#FFFFFF',
                                borderRadius: 1,
                                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                            }}>
                                {/* Available Balance */}
                                <Box sx={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    mb: tranferInProgressBalance > 0 ? 2 : 0
                                }}>
                                    <Typography variant="body2" color="text.secondary">
                                        Available Balance:
                                    </Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 700, color: 'success.main' }}>
                                        ₹{creditBalance.toFixed(2)}
                                    </Typography>
                                </Box>

                                {/* Transfer in Progress (if exists) */}
                                {tranferInProgressBalance > 0 && (
                                    <>
                                        <Divider sx={{ my: 1.5 }} />
                                        <Box sx={{ 
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between'
                                        }}>
                                            <Typography variant="body2" color="text.secondary">
                                                Transfer in Progress:
                                            </Typography>
                                            <Typography variant="h6" sx={{ fontWeight: 700, color: 'info.main' }}>
                                                ₹{tranferInProgressBalance.toFixed(2)}
                                            </Typography>
                                        </Box>
                                    </>
                                )}
                            </Box>

                            {/* Amount Input Box */}
                            <Box sx={{ 
                                p: 2, 
                                backgroundColor: '#FFFFFF',
                                borderRadius: 1,
                                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                            }}>
                                <TextField
                                    fullWidth
                                    label="Enter Amount"
                                    type="number"
                                    value={transferAmount}
                                    onChange={(e) => {
                                        setTransferAmount(e.target.value);
                                        setErrorMessage('');
                                    }}
                                    placeholder="0.00"
                                    InputProps={{
                                        startAdornment: <Typography sx={{ mr: 1 }}>₹</Typography>,
                                    }}
                                    inputProps={{
                                        min: 0,
                                        max: creditBalance,
                                        step: 0.01
                                    }}
                                    error={!!errorMessage}
                                    helperText={transferAmount && parseFloat(transferAmount) > creditBalance ? 
                                        'Amount exceeds available balance' : ''}
                                />
                            </Box>

                            {errorMessage && (
                                <Alert severity="error" sx={{ mt: 2 }}>
                                    {errorMessage}
                                </Alert>
                            )}
                        </>
                    )}
                </DialogContent>
                {showBankDetailsStep ? (
                    <Box sx={{ px: 2, pt: 1, pb: 0 }}>
                        <Typography variant="body2" color="text.secondary">
                            Bank details and PAN details should be verified before bank transfer can be initiated.
                        </Typography>
                    </Box>
                ) : null}
                <DialogActions sx={{ p: 2 }}>
                    {showBankDetailsStep ? (
                        <>
                            <Button
                                onClick={handleCloseTransferAmountDialog}
                                color="inherit"
                                sx={{ textTransform: 'none' }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleNextToBankTransfer}
                                variant="contained"
                                color="primary"
                                endIcon={<ArrowForwardIcon />}
                                sx={{ textTransform: 'none' }}
                                disabled={!hasBankDetails || mlmUserObj?.panvalidated !== true}
                            >
                                Next
                            </Button>
                        </>
                    ) : isTransferStatusScreen ? (
                        isTransferStatusConcluded ? (
                        <Button
                            onClick={handleCloseTransferStatusDialog}
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'none' }}
                        >
                            OK
                        </Button>
                        ) : null
                    ) : (
                        <>
                            <Button
                                onClick={handleBackToBankDetails}
                                color="inherit"
                                sx={{ textTransform: 'none' }}
                            >
                                Back
                            </Button>
                            <Button
                                onClick={handleInitiateTransfer}
                                variant="contained"
                                color="primary"
                                disabled={isLoading || !isAmountValid()}
                                sx={{ textTransform: 'none' }}
                            >
                                {isLoading ? 'Processing...' : 'Initiate'}
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>

            {/* Credit Statement Dialog */}
            <Dialog
                open={openStatementDialog}
                onClose={handleCloseStatementDialog}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        minHeight: '80vh',
                        maxHeight: '90vh'
                    }
                }}
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Credit Statement
                        </Typography>
                        <IconButton
                            onClick={handleCloseStatementDialog}
                            sx={{
                                color: 'text.secondary',
                                '&:hover': {
                                    backgroundColor: 'action.hover'
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <CreditStatement />
                </DialogContent>
            </Dialog>

            {/* Paid Credit - Bank Transfer History Dialog */}
            <Dialog
                open={openBankTransferDialog}
                onClose={handleCloseBankTransferDialog}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        minHeight: '80vh',
                        maxHeight: '90vh'
                    }
                }}
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Bank Transfer History
                        </Typography>
                        <IconButton
                            onClick={handleCloseBankTransferDialog}
                            sx={{
                                color: 'text.secondary',
                                '&:hover': {
                                    backgroundColor: 'action.hover'
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <BankTransferReq />
                </DialogContent>
            </Dialog>

            {/* Bank Transfer - Pending Requests Dialog */}
            <Dialog
                open={openPendingTransferDialog}
                onClose={handleClosePendingTransferDialog}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        minHeight: '80vh',
                        maxHeight: '90vh'
                    }
                }}
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Transfer History
                        </Typography>
                        <IconButton
                            onClick={handleClosePendingTransferDialog}
                            sx={{
                                color: 'text.secondary',
                                '&:hover': {
                                    backgroundColor: 'action.hover'
                                }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <BankTransferReq />
                </DialogContent>
            </Dialog>

            {/* Place this Snackbar OUTSIDE all Dialogs, at the end of your return */}
            <Snackbar
                open={showMinBalanceSnackbar}
                autoHideDuration={3000}
                onClose={() => setShowMinBalanceSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{
                    '& .MuiSnackbarContent-root': {
                        mt: '120px',
                        backgroundColor: (theme) => theme.palette.info.main,
                        color: (theme) => theme.palette.info.contrastText,
                    }
                }}
                message="Minimum credit balance of ₹200 is required to raise a bank transfer request."
            />
        </Grid>
    )
}
